module.exports = __webpack_public_path__ + "8a72db75c7ed6f1a11380da892ee1d97.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/places-to-hang-out-after-school/Mall2.jpg
// module id = 3564
// module chunks = 0